import { render, staticRenderFns } from "./MoreText.vue?vue&type=template&id=647b992b&scoped=true&"
import script from "./MoreText.vue?vue&type=script&lang=js&"
export * from "./MoreText.vue?vue&type=script&lang=js&"
import style0 from "./MoreText.vue?vue&type=style&index=0&id=647b992b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b992b",
  null
  
)

export default component.exports